export var AcademicDegreePrefixEnum;
(function (AcademicDegreePrefixEnum) {
    AcademicDegreePrefixEnum["A184"] = "184";
    AcademicDegreePrefixEnum["A183"] = "183";
    AcademicDegreePrefixEnum["A176"] = "176";
    AcademicDegreePrefixEnum["A211"] = "211";
    AcademicDegreePrefixEnum["A205"] = "205";
    AcademicDegreePrefixEnum["A206"] = "206";
    AcademicDegreePrefixEnum["A186"] = "186";
    AcademicDegreePrefixEnum["A185"] = "185";
    AcademicDegreePrefixEnum["A175"] = "175";
    AcademicDegreePrefixEnum["A177"] = "177";
    AcademicDegreePrefixEnum["A217"] = "217";
    AcademicDegreePrefixEnum["A178"] = "178";
    AcademicDegreePrefixEnum["A196"] = "196";
    AcademicDegreePrefixEnum["A129"] = "129";
    AcademicDegreePrefixEnum["A179"] = "179";
    AcademicDegreePrefixEnum["A180"] = "180";
    AcademicDegreePrefixEnum["A182"] = "182";
})(AcademicDegreePrefixEnum || (AcademicDegreePrefixEnum = {}));
export var AcademicDegreePostfixEnum;
(function (AcademicDegreePostfixEnum) {
    AcademicDegreePostfixEnum["A149"] = "149";
    AcademicDegreePostfixEnum["A134"] = "134";
    AcademicDegreePostfixEnum["A135"] = "135";
    AcademicDegreePostfixEnum["A136"] = "136";
    AcademicDegreePostfixEnum["A137"] = "137";
    AcademicDegreePostfixEnum["A147"] = "147";
    AcademicDegreePostfixEnum["A148"] = "148";
    AcademicDegreePostfixEnum["A141"] = "141";
    AcademicDegreePostfixEnum["A130"] = "130";
    AcademicDegreePostfixEnum["A145"] = "145";
    AcademicDegreePostfixEnum["A131"] = "131";
    AcademicDegreePostfixEnum["A199"] = "199";
    AcademicDegreePostfixEnum["A132"] = "132";
    AcademicDegreePostfixEnum["A146"] = "146";
    AcademicDegreePostfixEnum["A133"] = "133";
    AcademicDegreePostfixEnum["A138"] = "138";
    AcademicDegreePostfixEnum["A139"] = "139";
    AcademicDegreePostfixEnum["A140"] = "140";
    AcademicDegreePostfixEnum["A142"] = "142";
    AcademicDegreePostfixEnum["A201"] = "201";
    AcademicDegreePostfixEnum["A143"] = "143";
    AcademicDegreePostfixEnum["A151"] = "151";
    AcademicDegreePostfixEnum["A150"] = "150";
    AcademicDegreePostfixEnum["A144"] = "144";
    AcademicDegreePostfixEnum["A194"] = "194";
    AcademicDegreePostfixEnum["A154"] = "154";
    AcademicDegreePostfixEnum["A170"] = "170";
    AcademicDegreePostfixEnum["A197"] = "197";
    AcademicDegreePostfixEnum["A158"] = "158";
    AcademicDegreePostfixEnum["A161"] = "161";
    AcademicDegreePostfixEnum["A171"] = "171";
    AcademicDegreePostfixEnum["A162"] = "162";
    AcademicDegreePostfixEnum["A173"] = "173";
    AcademicDegreePostfixEnum["A168"] = "168";
    AcademicDegreePostfixEnum["A153"] = "153";
    AcademicDegreePostfixEnum["A156"] = "156";
    AcademicDegreePostfixEnum["A214"] = "214";
    AcademicDegreePostfixEnum["A155"] = "155";
    AcademicDegreePostfixEnum["A195"] = "195";
    AcademicDegreePostfixEnum["A169"] = "169";
    AcademicDegreePostfixEnum["A215"] = "215";
    AcademicDegreePostfixEnum["A190"] = "190";
    AcademicDegreePostfixEnum["A157"] = "157";
    AcademicDegreePostfixEnum["A213"] = "213";
    AcademicDegreePostfixEnum["A152"] = "152";
    AcademicDegreePostfixEnum["A159"] = "159";
    AcademicDegreePostfixEnum["A189"] = "189";
    AcademicDegreePostfixEnum["A160"] = "160";
    AcademicDegreePostfixEnum["A174"] = "174";
    AcademicDegreePostfixEnum["A191"] = "191";
    AcademicDegreePostfixEnum["A210"] = "210";
    AcademicDegreePostfixEnum["A198"] = "198";
    AcademicDegreePostfixEnum["A192"] = "192";
    AcademicDegreePostfixEnum["A212"] = "212";
    AcademicDegreePostfixEnum["A163"] = "163";
    AcademicDegreePostfixEnum["A172"] = "172";
    AcademicDegreePostfixEnum["A164"] = "164";
    AcademicDegreePostfixEnum["A165"] = "165";
    AcademicDegreePostfixEnum["A166"] = "166";
    AcademicDegreePostfixEnum["A167"] = "167";
    AcademicDegreePostfixEnum["A193"] = "193";
    AcademicDegreePostfixEnum["A200"] = "200";
    AcademicDegreePostfixEnum["A181"] = "181";
})(AcademicDegreePostfixEnum || (AcademicDegreePostfixEnum = {}));
// field disabled for now
/*export enum DegreeAwardedEnum {
  A238 = '238',
  A247 = '247',
  A203 = '203',
  A48 = '48',
  A261 = '261',
  A35 = '35',
  A106 = '106',
  A3 = '3',
  A34 = '34',
  A33 = '33',
  A43 = '43',
  A105 = '105',
  A104 = '104',
  A23 = '23',
  A11 = '11',
  A12 = '12',
  A126 = '126',
  A47 = '47',
  A57 = '57',
  A77 = '77',
  A237 = '237',
  A22 = '22',
  A239 = '239',
  A204 = '204',
  A287 = '287',
  A290 = '290',
  A241 = '241',
  A235 = '235',
  A125 = '125',
  A233 = '233',
  A234 = '234',
  A187 = '187',
  A50 = '50',
  A188 = '188',
  A229 = '229',
  A232 = '232',
  A207 = '207',
  A81 = '81',
  A113 = '113',
  A101 = '101',
  A98 = '98',
  A95 = '95',
  A120 = '120',
  A294 = '294',
  A70 = '70',
  A29 = '29',
  A128 = '128',
  A122 = '122',
  A30 = '30',
  A123 = '123',
  A13 = '13',
  A208 = '208',
  A80 = '80',
  A100 = '100',
  A288 = '288',
  A291 = '291',
  A267 = '267',
  A79 = '79',
  A58 = '58',
  A78 = '78',
  A102 = '102',
  A286 = '286',
  A289 = '289',
  A61 = '61',
  A59 = '59',
  A283 = '283',
  A46 = '46',
  A226 = '226',
  A224 = '224',
  A225 = '225',
  A115 = '115',
  A53 = '53',
  A73 = '73',
  A1 = '1',
  A44 = '44',
  A116 = '116',
  A82 = '82',
  A36 = '36',
  A5 = '5',
  A27 = '27',
  A49 = '49',
  A62 = '62',
  A19 = '19',
  A20 = '20',
  A4 = '4',
  A242 = '242',
  A243 = '243',
  A99 = '99',
  A96 = '96',
  A110 = '110',
  A236 = '236',
  A244 = '244',
  A202 = '202',
  A118 = '118',
  A227 = '227',
  A230 = '230',
  A245 = '245',
  A127 = '127',
  A51 = '51',
  A71 = '71',
  A246 = '246',
  A284 = '284',
  A7 = '7',
  A93 = '93',
  A88 = '88',
  A90 = '90',
  A91 = '91',
  A86 = '86',
  A89 = '89',
  A92 = '92',
  A41 = '41',
  A54 = '54',
  A74 = '74',
  A107 = '107',
  A216 = '216',
  A24 = '24',
  A273 = '273',
  A52 = '52',
  A56 = '56',
  A76 = '76',
  A55 = '55',
  A75 = '75',
  A121 = '121',
  A25 = '25',
  A117 = '117',
  A37 = '37',
  A28 = '28',
  A6 = '6',
  A119 = '119',
  A228 = '228',
  A231 = '231',
  A72 = '72',
  A8 = '8',
  A26 = '26',
  A32 = '32',
  A39 = '39',
  A15 = '15',
  A97 = '97',
  A17 = '17',
  A68 = '68',
  A67 = '67',
  A65 = '65',
  A285 = '285',
  A240 = '240',
  A263 = '263',
  A114 = '114',
  A109 = '109',
  A21 = '21',
  A124 = '124',
  A292 = '292',
  A293 = '293',
  A60 = '60',
  A31 = '31',
  A45 = '45',
  A2 = '2',
  A38 = '38',
  A265 = '265',
  A266 = '266',
  A223 = '223',
  A42 = '42',
  A221 = '221',
  A222 = '222',
  A14 = '14',
  A94 = '94',
  A16 = '16',
  A209 = '209',
  A66 = '66',
  A271 = '271',
  A10 = '10',
  A112 = '112',
  A111 = '111',
  A103 = '103',
  A18 = '18',
  A108 = '108',
  A220 = '220',
  A9 = '9',
  A268 = '268',
  A218 = '218',
  A219 = '219',
  A69 = '69',
  A40 = '40',
  A64 = '64',
  A63 = '63',
  A253 = '253',
  A83 = '83',
  A84 = '84',
  A85 = '85',
  A87 = '87',
  A248 = '248',
  A249 = '249',
  A250 = '250',
  A251 = '251',
  A252 = '252',
  A254 = '254',
  A255 = '255',
  A256 = '256',
  A257 = '257',
  A258 = '258',
  A259 = '259',
  A260 = '260',
  A262 = '262',
  A264 = '264',
  A269 = '269',
  A270 = '270',
  A272 = '272',
  A274 = '274',
  A275 = '275',
  A276 = '276',
  A277 = '277',
  A278 = '278',
  A279 = '279',
  A280 = '280',
  A281 = '281',
  A282 = '282',
}*/
